import { useSelector } from 'react-redux';
import { Permissions, SharedRootStore } from '@cowbell/data';

export const useScopes = (): Permissions[] =>
  useSelector((state: SharedRootStore) => state.scopes);
